import React from "react";
import "../Styles/About.css";
// import SecurityLogo from "../Images/martech-logo.webp";
import SecurityLogo from "../Images/TalkdevNew.webp";

const teamMembers = [
  // {
  //   name: "Kanika Goswami",
  //   role: "Editor-in-Chief",
  //   image:"https://talkdev.com/uploads/headshots/kanika_goswami.webp",
  //   // image:
  //   //   "https://ondot.com/wp-content/uploads/elementor/thumbs/Kanika-Goswami-Editor-in-Chief--pyke832f3d4q4aygptiz8la0mujwak6ijhxkzfoev8.gif",
  //   description:
  //     "Senior journalist with more than two decades in the media, and a deep understanding of enterprise technology content.",
  // },
  {
    name: "Sameer Datta",
    role: "Publisher",
    image:"https://talkdev.com/uploads/headshots/sameer_datta.webp",
    // image:
    //   "https://kgv.ae/wp-content/uploads/2023/03/Sameer-Datta-OnDot-jpg.webp",
    description:
      "Worked for global brands for over 15 years, driving business development, operations, and global media sales and marketing teams.",
  },
  {
    name: "Kelly Paice",
    role: "VP EMEA",
    image:"https://talkdev.com/uploads/headshots/kelly_paice.webp",
    // image:
    //   "https://ondot.com/wp-content/uploads/elementor/thumbs/Kelly-Paice-VP-EMEA-pyke8409a760fwx3kbxlt31h88f9i9a8vml2gpn0p0.gif",
    description:
      "Over fifteen years of expertise in eMedia as Head of Client Delivery and Ziff Davis, Kelly brings deep expertise in lead generation.",
  },
  // {
  //   name: "Martin Dela Cruz",
  //   role: "VP APAC",
  //   image:
  //     "https://ondot.com/wp-content/uploads/elementor/thumbs/Martin-Dela-Cruz%E2%80%8B-VP-APAC-pyke7zb2c0zktv3xbrwgym869b2ffrrl6zbn2btzk4.gif",
  //   description:
  //     "Martin is an expert in building start-up businesses and makes them visible in the arena. He has worked as Operations Manager, Technical Support, Investor Relations Executive, Pastry Chef, Recruiter, Author Partner, and Director of Business Development.",
  // },
  {
    name: "Eric Yoshizuru",
    role: "VP Americas",
    image:"https://talkcmo.com/uploads/headshots/eric_yoshizuru.webp",
    // image:
    //   "https://ondot.com/wp-content/uploads/elementor/thumbs/Eric-Yoshizuru-VP-AMER-pyke824kwj3fsoztvb4co3ik1goj2v2s7da3i5pt1g.gif",
    description:
      "A Strategic Marketing Professional with 15+ years of digital, product and corporate marketing experience in the technology sector; Eric has proven ability to drive measurable top and bottom line results by building exceptional marketing teams and programs.",
  },
  {
    name: "Pranab Ghosh",
    role: "Marketing Director",
    image:"https://talkcmo.com/uploads/headshots/pranab_ghosh.webp",
    // image:
    //   "https://ondot.com/wp-content/uploads/elementor/thumbs/Pranab-Ghosh-Director-Marketing-OnDOt-pyke808wiv0v5h2k6ab3j3zmuoxsngvbj3z4jlsldw.gif",
    description:
      "Pranab has a track record of working on complex projects from scratch; scaling them up into multi-million dollar businesses. At Ondot, he heads the marketing team and strategizes for establishing the brand Ondot globally, as a leader in B2B technology media marketing.",
  },
];

const About = () => {
  return (
    <>
      <div className="container container-max">
        <div className="row">
          <h1 className="fw-bold h2 py-1 mt-3 borderB">About Us</h1>
          <div className="col-md-8">
            <h2 className="fw-bold h4 mt-3">
              Acing the Science of Marketing Technologies
            </h2>
            <p className="mt-3">
              As technology becomes the Strategic Differentiator in every
              business function, learn about the global insights of marketing
              leadership- how to leverage innovative marketing technologies that
              are rapidly acquiring the digital edge.
            </p>
            <p className="mt-3">
              TalkDev is a digital platform that creates conversations on
              Marketing Technology and Digital Transformation of the marketing
              function. Through active and interesting news, views and
              interviews with industry leaders, it will afford global exposure
              of the best Strategies and Innovations – paving a path for Smarter
              Marketing Decisions.
            </p>
          </div>
          <div className="col-md-4 AboutLogo">
            <img
              style={{ width: "70%" }}
              className="m-auto"
              src={SecurityLogo}
              alt="About Us Logo"
            />
          </div>
        </div>
      </div>

      <div className="container container-max mt-5">
        <div className="row">
          <h3 className="fw-bold borderB py-1 h4">The Team</h3>
          <div className="col-md-12">
            <div className="row">
              {teamMembers?.map((member, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div className="card bg-black p-3">
                    <img
                      className="team-member-img"
                      src={member.image}
                      style={{ borderRadius: "10px" }}
                      alt={member.name}
                    />
                    <div
                      className="p-md-3 colorRed card bg-black"
                      style={{ fontSize: "14px", padding: "10px" }}
                    >
                      <div id="future"></div>
                      <div className="fw-bold border-bottom card-title text-white h5">
                        {member?.name}
                        <span>
                          <p
                            className="mt-1 text-white"
                            style={{ fontSize: "15px" }}
                          >
                            {member?.role}
                          </p>
                        </span>
                      </div>
                      <p className="cardText card-text text-white">
                        {member?.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
